import { z } from "zod";

export const schema = z.object({});

export type InputType = z.infer<typeof schema>;

export type LandingStatsOutput = {
  forme7j: { numero: number; sorties: number; surTotal: number }[];
  // Absents quand la famille « pronostics » suit la frontière (listes réservées au compte).
  recordsImminents?: { numero: number; ecart: number; ecartMax: number; percent: number }[];
  comeback: { numero: number; ecartAvant: number } | null;
  topFrequencies?: { numero: number; count: number; percent: number }[];
  totalTirages: number;
  lastTirage: {
    date: string;
    numeros: number[];
    jokerPlus: string | null;
    aiAnalysisExcerpt?: string | null;
  };
};

export const getLandingStats = async (init?: RequestInit): Promise<LandingStatsOutput> => {
  const result = await fetch(`/_api/public/landing-stats`, {
    method: "GET",
    ...init,
    headers: {
      "Content-Type": "application/json",
      ...(init?.headers ?? {}),
    },
  });

  const text = await result.text();
  if (!result.ok) {
    const errorObject = JSON.parse(text) as { error: string };
    throw new Error(errorObject.error);
  }
  const data = JSON.parse(text);
  // Ensure arrays are present even if backend returns partial data
  return {
    forme7j: data.forme7j ?? [],
    recordsImminents: data.recordsImminents ?? [],
    comeback: data.comeback ?? null,
    topFrequencies: data.topFrequencies ?? [],
    totalTirages: data.totalTirages ?? 0,
    lastTirage: data.lastTirage ?? null,
  } as LandingStatsOutput;
};
